export const isValidEmail = (email: string) => {
  return email ? email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) : true;
};
